<template>
  <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="2" height="7" rx="1" fill="#D64633"/>
    <rect x="3" width="2" height="7" rx="1" fill="#D64633"/>
  </svg>
</template>